import { gql } from 'Utils/apolloClient'

const installmentsQuery = gql`
  query Installments($filters: InstallmentFiltersAttributes, $page: Int, $perPage: Int,
    $slug: String!, $sort: InstallmentsSortAttributes) {
    campground(slug: $slug) {
      id
      hasLateFeeConfig
      isCountryUs
      installments(filters: $filters, page: $page, perPage: $perPage, sort: $sort) {
        nodes {
          id
          createdAt
          dueOn
          number
          paymentMethod {
            ... on PaymentMethodStripeAch {
              lastFour
            }
            ... on PaymentMethodStripeCard {
              lastFour
            }
            __typename
          }
          processingFeeTotal {
            display
          }
          refundStatus
          reservation {
            id
            email
            firstName
            lastName
            site {
              name
            }
          }
          paidAt
          sentAt
          state
          subtotal
          total {
            display
            displayWithCode
          }
          totalRefunded {
            display
          }
          updatedAt
        }
        pagesCount
        totalCount
      }
      isInventory
    }
  }`

export default installmentsQuery
